import * as fiestabet from './Banner.styles.fiestabet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  fiestabet,
};
